<template>
    <div>
        <v-container fluid class="" :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">
                <v-row>
                    <v-col
                        cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                    >
                        <h1 class="mt-6 mb-6">{{ $t('headings.Get to grips with lost property') }}</h1>

                        <vimeo-player ref="player" video-id="397128650" @ready="onReady" class="player-container" :options="options">
                        </vimeo-player>

                        <h2 class="mt-6 mb-3">{{ $t('headings.Sign up as an organisation to start scanning our Smart tags') }}</h2>

                        <v-btn class="mb-6" rounded elevation="0" color="primary" block @click="navigate('sign-up-organisation')">
                          {{ $t('buttons.Sign up organisation') }}
                        </v-btn>

                        <OrganisationsSummary />

                        <OrganisationsContent />

                        <v-btn class="mb-12" rounded elevation="0" color="primary" block @click="navigate('sign-up-organisation')">
                          {{ $t('buttons.Sign up organisation') }}
                        </v-btn>

<!--                        <vimeo-player ref="player" video-id="1007999399" @ready="onReady" class="player-container" :options="options">-->
<!--                        </vimeo-player>-->

                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <v-container fluid class="white">
          <v-container class="contain-width">
          <v-row class="mt-12 mb-12">
            <v-col
                cols="12"
                md="5"
                offset-md="1"
            >
              <img
                  :src="require('@/assets/bennet-memorial.jpg')"
                  alt="Bennet Memorial School"
              >
            </v-col>
            <v-col
                cols="12"
                md="4"
                offset-md="1"
            >
              <h3 class="h3 mb-8">Bennett Memorial Diocesan School</h3>
              <blockquote class="mb-8">Find My Kit has significantly improved the management of lost property at our school. With 1600 students previously losing around 4000 unnamed items annually, most would go unclaimed and be donated to charity. Since promoting Find My Kit, more items are properly labelled, reducing lost property and increasing parental awareness. Returning items is now easier, as tagged items can be quickly scanned to identify the owner, saving time and preventing lost items from piling up. Parents also receive notifications when their child's item is found, making the system highly beneficial for everyone involved.</blockquote>

              <div class="d-flex flex-row">
                <img
                    :src="require('@/assets/arms-of-bennett-memorial.jpg')"
                    alt="Arms of Bennet Memorial School"
                    width="100"
                    class="mr-6"
                >
                <div>
                  <p class="credit mb-4">William Shuster</p>
                  <p class="credit-location">School Lost Property Manager at Bennett Memorial Diocesan School</p>
                </div>
              </div>
            </v-col>
          </v-row>
          </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer.vue'
    import {i18n} from "../i18n";
    import OrganisationsSummary from "./OrganisationsSummary";
    import OrganisationsContent from "./OrganisationsContent";
    import {mapState} from "vuex";

    export default {
        name: "Organisations",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Organisations'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('Sign up as an organisation to start scanning our Smart tags') + '.' + i18n.t('Lost property in schools, leisure centres, sports clubs, gyms; {brand} has a revolutionary solution', {brand: this.capitalizeFirstLetter(this.brand)}) + '.' }
            ]
          }
        },
        components: {
          OrganisationsSummary,
          OrganisationsContent,
            'Footer': Footer
        },
        data () {
            return {
                options: {'responsive': true, 'dnt': true},
                playerReady: false
            }
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          })
        },
        mounted () {

            window.scrollTo(0,0);

            window.prerenderReady = true;
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            },
            onReady() {
                this.playerReady = true
            },
            play () {
                this.$refs.player.play()
            },
            stop () {
                this.$refs.player.stop()
            },
        }
    }
</script>

<style scoped lang="scss">
    .v-card__actions {
        padding: 16px;
        justify-content: flex-end;
    }
    .info-card {
        border-radius: 15px;
        border: none !important;
    }
    blockquote {
      font-size: 1.3rem;
      line-height: 1.9rem;
      color: var(--v-primary-base);
      font-style: italic;
      font-weight: 400;
      font-family: "Open Sans", sans-serif;
      text-indent: -0.45rem;
      quotes: "“" "”" "‘" "’";
      span {
        font-size: 4rem;
      }
    }
    @supports ( hanging-punctuation: first) {
      blockquote {
        text-indent: 0;
        hanging-punctuation: first;
      }
    }

    blockquote::before {
      content: open-quote;
    }
    blockquote::after {
      content: close-quote;
    }
    .credit {
      font-weight: 600;
    }
    .credit-location {

    }

    .h3 {
      font-size: 1.4rem;
      line-height: 2rem;
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-style: normal;
      @media only screen and (max-width: 959px) {
        font-size: 1.5rem;
        line-height: 2rem;
      }
    }
</style>
